export const getLocationChanged = ({ modal }) => modal.get('prevLocation')
